import { render } from "./vButton.vue?vue&type=template&id=4715e353&scoped=true"
import script from "./vButton.vue?vue&type=script&lang=js"
export * from "./vButton.vue?vue&type=script&lang=js"

import "./vButton.vue?vue&type=style&index=0&id=4715e353&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\danil\\PersonalData\\WebsiteDevelopment\\GitHub\\biorobot-factory\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4715e353"]])

export default __exports__